import { render, staticRenderFns } from "./CARatiosFilters.vue?vue&type=template&id=4bd8fe5e&scoped=true"
import script from "./CARatiosFilters.vue?vue&type=script&lang=js"
export * from "./CARatiosFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd8fe5e",
  null
  
)

export default component.exports